/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { combineReducers } from 'redux';

import { auth } from './auth/reducers';
import { createCluster } from './createCluster/reducers';
import { createOrganization } from './createOrganization/reducers';
import { createProject } from './createProject/reducers';
import { createService } from './createService/reducers';
import { notifications } from './notifications/reducers';
import { notifier } from './notifier/reducers';
import { organizationDetails, organizations } from './organization/reducers';
import { plan } from './plan/reducers';
import { projects } from './projects/reducers';
import { resources } from './resources/reducers';
import { updateCluster } from './updateCluster/reducers';

export const rootReducer = combineReducers({
  auth,
  organizations,
  organizationDetails,
  plan,
  notifications,
  projects,
  notifier,
  createCluster,
  updateCluster,
  createOrganization,
  createProject,
  createService,
  resources,
});
